<template>
  <div class="detail-invoiceinfo-wrap">
    <div class="apply-detail-bottom">
      <div class="etail-bottom-title">
        <h4 class="apply-detail-bottom__title">{{title}}</h4>
      </div>
      <!-- 两层数组 -->
      <ul v-if="hasChildren" class="invoice-data-list detail-content-bolck">
        <li v-for="(item, index) in data" :key="index">
          <div v-for="(itemChildren, indexChildren) in item" :key="indexChildren + 'children'">
            <div v-if="routeOperate === 2 && itemChildren.name === 'input'" class="invoice-data-list__bord">
              <span class="invoice-label invoice-label-input" :class="{'label-request': itemChildren.request}">{{itemChildren.label}}</span>
              <span class="invoice-value">
                <Input v-model.trim="itemChildren.value" placeholder="请输入" />
              </span>
            </div>
            <div v-if="itemChildren.name !== 'input'" class="invoice-data-list__bord">
              <!-- {{itemChildren.name}} -->
              <span class="invoice-label">{{itemChildren.label}}</span>
              <span v-if="itemChildren.label === '发票文件'" class="invoice-value invoice-value-file">
                <span>{{itemChildren.value}}</span>
                <span class="invoice-value-btn"><em class="yjh-active" @click="showImg">预览</em><em class="yjh-active" @click="downImg">下载</em></span>
              </span>
              <span
                v-else class="invoice-value"
                :class="{'invoice-value-url yjh-active': itemChildren.name === 'shunFengUrl'}"
                @click.stop="changeUrl(itemChildren.name, itemChildren.value, itemChildren.num)"
              >{{itemChildren.value}}</span>
            </div>
          </div>
        </li>
      </ul>
      <!-- 一层数组 -->
      <ul v-else class="invoice-data-list detail-content-bolck invoice-address">
        <li v-for="(item, index) in data" :key="index">
          <div v-if="routeOperate === 2 && item.name === 'input'" class="invoice-data-list__bord">
            <span class="invoice-label invoice-label-input" :class="{'label-request': item.request}">{{item.label}}</span>
            <span class="invoice-value">
              <Input v-model.trim="item.value" placeholder="请输入" />
            </span>
          </div>
          <div v-if="item.name !== 'input'" class="invoice-data-list__bord">
            <span class="invoice-label">{{item.label}}</span>
            <span class="invoice-value">{{item.value}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    data: Array,
    title: String,
    routeOperate: Number
  },
  computed: {
    hasChildren() {
      return this.data[0] && Array.isArray(this.data[0])
    }
  },
  methods: {
    showImg() {
      this.$emit('toggleInvoiceImg', true)
    },
    downImg() {
      this.$emit('downloadInvoiceImg')
    },
    // 物流链接
    changeUrl(name, val, no) {
      if (name === 'shunFengUrl') {
        if (no.includes('SF')) {
          const url = `https://www.sf-express.com/cn/sc/dynamic_function/waybill/#search/bill-number/${no}`
          window.open(url)
        } else {
          window.open('https://www.sf-express.com/cn/sc/dynamic_function/waybill/')
          // window.open(val)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.apply-detail-bottom {
  padding: 40px 30px 0 30px;
  font-size: 12px;
  .etail-bottom-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .apply-detail-btn {
    font-size: 12px;
    color: $blue;
  }
  .apply-detail-bottom__title {
    font-size: 14px;
    font-weight: 400;
  }
  .apply-detail-bottom__detail {
    margin-bottom: 10px;
  }
  .apply-detail__btn {
    color: $blue;
    text-decoration:underline;
    margin-top: 5px;
  }
  .detail-content-bolck {
    border-bottom: solid 1px $border;
  }
  .detail-content-bolck__none {
    text-align: center;
    padding-top: 52px;
    padding-bottom: 50px;
  }
  .detail-content-bolck__table {
    padding-bottom: 20px;
    border-bottom: none;
  }
  /deep/ .v-table-views .v-table-title-cell {
    padding-right: 0 !important;
    color: $fontBlack;
  }
  .invoice-data-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 24px;
    & li {
      display: flex;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 20px;
      & > div{
        display: flex;
        align-items: flex-start;
        width: 50%;
      }
      & .invoice-data-list__div {
        width: 50%;
      }
      & .invoice-data-list__bord {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        .invoice-label-input {
          line-height: 32px;
        }
        /deep/ .ivu-input {
          height: 32px;
          width: 210px;
        }
      }
      &:last-child {
        margin-bottom: 30px;
      }
    }
  }
  .invoice-label,
  .invoice-value {
    display: inline-block;
    word-break: break-all;
  }
  .invoice-label {
    width: 90px;
    text-align: right;
    margin-right: 10px;
    &:after {
      content: ':'
    }
  }
  .invoice-value {
    width: 300px;
  }
  .invoice-value-file {
    display: flex;
    align-items: flex-start;
  }
  .invoice-value-btn {
    margin-left: 20px;
    min-width: 65px;
    color: $blue;
    text-decoration: underline;
    & > em {
      font-style: normal;
    }
    & > em:last-child {
      margin-left: 16px;
    }
  }
  .invoice-value-url {
    color: $blue;
    text-decoration: underline;
  }
  .invoice-address {
    & > li {
      width: 50%;
    }
  }
}
.label-request {
  &:before {
  }
}
</style>
